export default "__VITE_ASSET__xTFtfmG8__"